<template>
  <section class="responsible-pititim-prices">
    <div class="responsible-pititim-prices__box">
      <div class="responsible-pititim-prices__header">
        <h3>
          Valores Pititim referentes ao ano de
          <strong>{{ calendarYear }}</strong>
        </h3>
      </div>

      <div class="responsible-pititim-prices__content">
        <template v-if="price">
          <div class="responsible-pititim-prices__card">
            <div class="responsible-pititim-prices__card-header">
              <h4>Preço por módulo</h4>
            </div>

            <div class="responsible-pititim-prices__card-body">
              <div class="responsible-pititim-prices__price-display">
                {{ formatBRL(price.price) }} / módulo
              </div>

              <div class="responsible-pititim-prices__divider"></div>

              <div class="responsible-pititim-prices__material-fee">
                <span>Taxa de material</span>
                <strong>{{ formatBRL(price.material_fee) }}</strong>
              </div>

              <div class="responsible-pititim-prices__divider"></div>

              <table class="responsible-pititim-prices__table">
                <thead>
                  <tr>
                    <th>Módulo</th>
                    <th>Desconto</th>
                    <th>Valor mensal</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="discount in price.discounts"
                    :key="discount.modules"
                    class="responsible-pititim-prices__table-row"
                  >
                    <td>
                      {{ discount.modules }}
                      {{ discount.modules === 1 ? "módulo" : "módulos" }}
                    </td>
                    <td>{{ discount.discount }}%</td>
                    <td class="responsible-pititim-prices__value">
                      {{ formatBRL(calculateMonthly(discount.modules, discount.discount)) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </template>

        <div v-else class="responsible-pititim-prices__empty">
          <p>Valores não disponíveis no momento</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { formatBRL } from "@/utils/formatBRL";
import { calculateMonthlyPititimPrice } from "@/utils/pititimPrice";

export default {
  name: "PititimPriceView",
  props: {
    price: {
      type: Object,
      default: null,
    },
    calendarYear: {
      type: [String, Number],
      default: "",
    },
  },
  methods: {
    formatBRL,
    calculateMonthly(modules, discount) {
      return calculateMonthlyPititimPrice(modules, this.price.price, discount);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variablesSchool1.scss";

.responsible-pititim-prices {
  margin-bottom: 45px;

  &__title {
    color: $purple;
    margin-bottom: 20px;
    font-size: 24px;
    font-weight: 700;
  }

  &__box {
    border-radius: 12px;
    overflow: hidden;
    background: $white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }

  &__header {
    background: linear-gradient(135deg, $green1, $blue);
    color: $white;
    padding: 20px 24px;
    text-align: center;

    h2,
    h3 {
      margin: 0;
      font-size: 22px;
      font-weight: 600;
      line-height: 1.4;
    }

    strong {
      font-weight: 700;
    }
  }

  &__content {
    background: $grey6;
    padding: 32px 24px;
    display: flex;
    justify-content: center;
  }

  &__card {
    background: $white;
    border-radius: 10px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
    width: 100%;
    max-width: 480px;
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
  }

  &__card-header {
    background: linear-gradient(135deg, $green1, $blue);
    color: $white;
    padding: 16px 20px;
    border-radius: 10px 10px 0 0;

    h4 {
      margin: 0;
      font-size: 16px;
      font-weight: 700;
    }
  }

  &__card-body {
    padding: 20px;
  }

  &__price-display {
    text-align: center;
    font-size: 22px;
    font-weight: 700;
    color: $grey3;
    padding: 12px 0;
  }

  &__divider {
    height: 1px;
    background: $grey5;
    margin: 16px 0;
  }

  &__material-fee {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: $grey3;
    font-size: 14px;

    strong {
      font-size: 16px;
    }
  }

  &__table {
    width: 100%;
    border-collapse: collapse;

    th,
    td {
      padding: 10px 16px;
      text-align: left;
      font-size: 14px;
    }

    thead th {
      background: $grey8;
      color: $blue;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.3px;
      font-size: 12px;
      border-bottom: 2px solid $grey7;
    }

    tbody td {
      color: $grey3;
      border-bottom: 1px solid $grey7;
    }
  }

  &__table-row {
    &:nth-child(even) {
      background: $grey2;
    }
  }

  &__value {
    font-weight: 700;
    color: $green3;
  }

  &__empty {
    text-align: center;
    padding: 40px 20px;
    color: $grey4;
    font-size: 16px;
    font-weight: 600;
  }
}

@media (max-width: 576px) {
  .responsible-pititim-prices {
    &__card {
      max-width: 100%;
    }

    &__price-display {
      font-size: 18px;
    }

    &__table {
      th,
      td {
        padding: 8px 12px;
        font-size: 13px;
      }
    }
  }
}
</style>
